import accessAuth from "./AuthControl"
import accessDashboard from "./DashboardControl"
import accessMaster from "./MasterControl"
import accessUsers from "./UsersControl"
import accessSettings from "./SettingsControl"
import accessCompany from "./CompanyControl"
import accessOnlineClass from "./OnlineClassControl"
import accessAssign from "./AssignControl"
import accessAssignment from "./AssignmentControl"
import accessPaperGeneration from "./PaperGenerationControl"
import accessClass from "./ClassControl"
import accessDay from "./DayControl"
import accessTopic from "./TopicControl"
import accessRegistration from "./RegistrationControl"
import accessPayment from "./PaymentControl"
import accessPaymentHistory from "./PaymentHistoryControl"
import accessStudentExam from "./StudentExamControl"

const RoutesMap = {
    ...accessAuth,
    ...accessDashboard,
    ...accessMaster,
    ...accessSettings,
    ...accessUsers,
    ...accessCompany,
    ...accessOnlineClass,
    ...accessAssign,
    ...accessAssignment,
    ...accessPaperGeneration,
    ...accessClass,
    ...accessDay,
    ...accessTopic,
    ...accessRegistration,
    ...accessPayment,
    ...accessPaymentHistory,
    ...accessStudentExam,
}

export default RoutesMap;